import _ from 'lodash'
import { useForm } from 'react-hook-form'

import api from '../../../services/api'
import useModal from '../../../hooks/useModal'
import Utils from '../../../utils'

import * as S from '../Modal.styles'

import { ReactComponent as CloseIcon } from '../../../assets/images/close_delete_icon.svg'
import { BasicTextFieldForForm, BasicNumberInputForForm } from '../../InputBoxes'
import { CompleteBtn } from '../../Buttons'

export default function UpdateSubjectModal(props) {
  const { control, handleSubmit } = useForm()
  const { openModal, closeModal } = useModal()

  async function addSubject(data) {
    const isSuccess = await api.post(`sessional-plans/${props.sessionalPlanId}/total-quantities`, data)
      .then(result => result.status === 201)
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })

    if (! isSuccess) return
    await api.get(`/sessional-plans/${props.sessionalPlanId}`)
      .then(result => props.setSessionalPlan(result.data))
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })

    closeModal()
  }

  async function modifySubject(data) {
    try {
      api.put(`sessional-plans/${props.sessionalPlanId}/total-quantities/${props?.totalQuantity?.totalQuantityId}`, data).then(result => {
        let _sessionalPlan = _.cloneDeep(props.sessionalPlan)
        const modifiedIdx = _.findIndex(_sessionalPlan.totalQuantityList, tq => tq.totalQuantityId === props?.totalQuantity?.totalQuantityId)
        _sessionalPlan.totalQuantityList[modifiedIdx] = result.data.totalQuantity
        props.setSessionalPlan(_sessionalPlan)
        closeModal()
      })
    } catch (err){
      console.error(err)
    }
  }

  return (
    <>
      <S.Background />
      <S.ModalBox height='400px' width='350px'>
        <CloseIcon
          className='close-icon'
          width='25px'
          onClick={closeModal}
        />
        <S.ModalContents width='80%' height='80%'>
          <S.Title>{props?.totalQuantity?.totalQuantityId ? '세션 영역 수정' : '세션 영역 추가'}</S.Title>
          <S.FlexContainer marginTop='30px' marginBottom='20px'>
            <BasicTextFieldForForm
              control={control}
              defaultValue={props?.totalQuantity?.subjectCategory || null}
              label='분류'
              name='subjectCategory'
              rules={{ required: '분류를 입력해 주세요' }}
              style={{ marginRight: '10px' }}
            />
            <BasicTextFieldForForm
              control={control}
              defaultValue={props?.totalQuantity?.subject || null}
              label='영역'
              name='subject'
              rules={{ required: '영역을 입력해 주세요' }}
            />
          </S.FlexContainer>
          <S.FlexContainer marginTop='35px' marginBottom='20px'>
            <BasicNumberInputForForm
              control={control}
              defaultValue={props?.totalQuantity?.totalQuantityAmount || 0}
              label='session 분량'
              name='totalQuantityAmount'
              maxWidth='50%'
              rules={{
                required: 'session 분량을 입력해 주세요',
                validate: (v) => Utils.isZeroOrPosInt(v) || '0보다 크거나 같은 정수여야 합니다.',
            }}
              style={{ marginRight: '10px' }}
            />
            <BasicTextFieldForForm
              control={control}
              defaultValue={props?.totalQuantity?.unit || null}
              label='단위 (e.g. page)'
              name='unit'
              rules={{ required: '단위를 입력해 주세요' }}
            />
          </S.FlexContainer>
          <BasicTextFieldForForm
            control={control}
            defaultValue={props?.totalQuantity?.totalQuantityMemo || null}
            label='메모'
            name='totalQuantityMemo'
            minWidth='100%'
            style={{ marginTop: '40px' }}
          />
          <S.BtnContainer>
            <CompleteBtn
              fontSize='1em'
              height='40px'
              width='100%'
              onClick={handleSubmit(props?.totalQuantity?.totalQuantityId ? modifySubject : addSubject)}
            >확인
            </CompleteBtn>
          </S.BtnContainer>
        </S.ModalContents>
      </S.ModalBox>
    </>
  )
}